import { RefObject, useEffect } from 'react';

export function useClickOutside(
  ref: RefObject<HTMLElement>,
  onClick: () => void
) {
  useEffect(() => {
    const current = ref.current;

    function handleInteractionOutside(event: Event) {
      if (!!current && !current.contains(event.target as Node)) {
        onClick();
      }
    }

    document.addEventListener('mousedown', handleInteractionOutside);
    document.addEventListener('focusin', handleInteractionOutside);

    return () => {
      document.removeEventListener('mousedown', handleInteractionOutside);
      document.removeEventListener('focusin', handleInteractionOutside);
    };
  }, [onClick, ref]);
}
